import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Notifications from '@hellodarwin/icons/dist/icons/Notifications';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslations } from '../../../../features/providers/translations-provider';
import Button from '../../../common/button';
import Typography from '../../../common/typography';
import { GrantNotificationButtonContainer } from './styles';
const GrantNotification = ({ grant, animate, topInset, handleGrantNotification, }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    const [hovered, setHovered] = useState(false);
    const [selected, handleSelected] = useState(grant.grant_is_subscribed);
    const [unsubscribing, setUnsubscribing] = useState(false);
    const [unsubscribed, setUnsubscribed] = useState(false);
    const handleNotification = (isSubscribing) => {
        handleGrantNotification(grant, isSubscribing);
    };
    useEffect(() => {
        handleSelected(grant.grant_is_subscribed);
    }, [grant.grant_is_subscribed]);
    const wantNotification = !selected && !unsubscribed;
    const wantUnsubscribe = !!selected && !unsubscribing;
    const handleSelect = () => {
        if (wantNotification) {
            handleNotification(true);
        }
        else {
            if (wantUnsubscribe) {
                setUnsubscribing(true);
            }
            else {
                setUnsubscribing(false);
                setUnsubscribed(true);
                setTimeout(() => setUnsubscribed(false), 2000);
                handleSelected(false);
                handleNotification(false);
            }
        }
    };
    const handleMouseEnter = () => setHovered(true);
    const handleMouseLeave = () => {
        setHovered(false);
    };
    return (_jsxs(GrantNotificationButtonContainer, { "$active": hovered, "$animate": animate, "$topInset": topInset, children: [_jsx(Typography, { children: hovered &&
                    (wantNotification
                        ? t('grant_notification|grant_notification_subscribe')
                        : wantUnsubscribe
                            ? t('grant_notification|grant_notification_unsubscribe')
                            : unsubscribing
                                ? t('grant_notification|grant_notification_unsubscribe_verification')
                                : unsubscribed
                                    ? t('grant_notification|grant_notification_unsubscribe_confirmed')
                                    : '') }), _jsx(Button, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, defaultStyle: theme.colors.purple_2, headingIcon: _jsx(Notifications, { size: 24, filled: selected, fillingColor: theme.colors.purple_2 }), size: "square", transparent: true, onClick: handleSelect })] }));
};
export default GrantNotification;
